import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import { updateChatLabel } from '../api/chatApi';

const SidebarChatEditLabel = ({
  activeChat,
  getAllChats,
  chatLabel,
  setIsEditLabel,
}) => {
  const [newLabel, setNewLabel] = useState(chatLabel);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const updateLabel = async () => {
    setIsEditLabel(false);
    await updateChatLabel(activeChat, newLabel === "" ? "Untitled" : newLabel);
    await getAllChats({});
  };

  const handleEnter = async (event) => {
    if (event.key === "Enter") {
      updateLabel();
      event.preventDefault();
    }
  };
  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className="bg-inherit flex w-full text-black"
    >
      <input
        ref={inputRef}
        onBlur={() => {
          if (chatLabel === newLabel) {
            setIsEditLabel(false);
          } else {
            updateLabel();
          }
        }}
        type="text"
        placeholder={""}
        value={newLabel}
        onChange={(e) => setNewLabel(e.target.value)}
        onKeyDown={(e) => handleEnter(e)}
        className="bg-inherit text-sm text-white w-full mr-1 outline-none px-1 focus:outline focus:outline-indigo-400"
      />
    </div>
  );
};

export default SidebarChatEditLabel;
